export default __webpack_public_path__ + "static/Hybrid-8cbc021ee752617e501c5acab83008ab.png";